/**
 * @generated SignedSource<<ac84d180d5b594c7163918f01f9799d7>>
 * @relayHash 15c4d5cd83724d2c377e03e67f0401a0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 04f1e2e12365470f1a82e7ad525acea578598fdcf526eb7c64d848b023824aba

import type { ConcreteRequest } from 'relay-runtime';
export type ContentOwnershipDialogRefetchOnMutationQuery$variables = {
  contentId: string;
};
export type ContentOwnershipDialogRefetchOnMutationQuery$data = {
  readonly contentContributors: {
    readonly isOwnerContributor: boolean | null | undefined;
  } | null | undefined;
};
export type ContentOwnershipDialogRefetchOnMutationQuery = {
  response: ContentOwnershipDialogRefetchOnMutationQuery$data;
  variables: ContentOwnershipDialogRefetchOnMutationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
      }
    ],
    "concreteType": "ContentContributors",
    "kind": "LinkedField",
    "name": "contentContributors",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "isOwnerContributor"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ContentOwnershipDialogRefetchOnMutationQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ContentOwnershipDialogRefetchOnMutationQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "15c4d5cd83724d2c377e03e67f0401a0",
    "id": "04f1e2e12365470f1a82e7ad525acea578598fdcf526eb7c64d848b023824aba",
    "metadata": {},
    "name": "ContentOwnershipDialogRefetchOnMutationQuery",
    "operationKind": "query",
    "text": "query ContentOwnershipDialogRefetchOnMutationQuery($contentId:ID!){contentContributors(id:$contentId){isOwnerContributor}}"
  }
};
})();

(node as any).hash = "3c1d5e334c9e0f12e92785d43b19032c";

export default node;
